const exportCSV = (
  data,
  columns,
  filename = "report",
  headerType = "label"
) => {
  if (!data.length) return;

  // 1. Header
  let header = null;
  if (headerType === "label") {
    header = columns.map((c) => `"${c.label.replace(/"/g, '""')}"`).join(",");
  } else if (headerType === "key") {
    header = columns.map((c) => `"${c.key.replace(/"/g, '""')}"`).join(","); // put key as header
  }

  // 2. Rows
  const rows = data.map((row) =>
    columns
      .map((c) => {
        let value = row[c.key];

        if (c.format) value = c.format(value);
        if (value == null) value = "";

        // Escape CSV rules
        value = value.toString().replace(/"/g, '""');

        return `"${value}"`;
      })
      .join(",")
  );

  // 3. Final CSV string with UTF-8 BOM for Excel
  const csvString = "\uFEFF" + [header, ...rows].join("\r\n");

  // 4. Download file
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();

  URL.revokeObjectURL(url);
};

export default exportCSV;
